import { FiltroLista, IFiltroLista } from 'src/app/filter/filtro-lista';


export interface IFiltroListaPedidoCompra extends IFiltroLista{

  CC7NUM: string;
  CC7FORNECE: string;
  CC7LOJA: string;
  CC7FORNECELOJA: string;
  CC7SOLICIT: string;
  CC7USER: string;
  CC7USER_IN: string | Array<string>;
  DC7EMISSAO_DE: Date | undefined;
  DC7EMISSAO_ATE: Date | undefined;
  DC7DATPRF_DE: Date | undefined;
  DC7DATPRF_ATE: Date | undefined;

}

export class FiltroListaPedidoCompra extends FiltroLista {

  dados: IFiltroListaPedidoCompra = this.setDefault();
  timeout = this.getDataString();

  public setDefault(): IFiltroListaPedidoCompra {
    return {
      page: 1,
      pageSize: 20,
      filter: '',
      order: '',

      CC7NUM: '',
      CC7FORNECE: '',
      CC7LOJA: '',
      CC7FORNECELOJA: '',
      CC7SOLICIT: '',
      CC7USER: '',
      CC7USER_IN: '',
      DC7EMISSAO_DE: this.getData(-30),
      DC7EMISSAO_ATE: this.getData(),
      DC7DATPRF_DE: undefined,
      DC7DATPRF_ATE: undefined,
    };
  }

}
